import { Box, Icon, Tooltip } from "@chakra-ui/react";
import { LuCircle, LuCircleCheck } from "react-icons/lu";

interface TaskCompleteToggleIconProps {
  isCompleted: boolean;
  isDisabled?: boolean;
  onClick: () => void;
  size?: number;
}

export default function TaskCompleteToggleIcon({
  isCompleted,
  isDisabled = false,
  onClick,
  size = 5,
}: TaskCompleteToggleIconProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isDisabled) {
      onClick();
    }
  };

  return (
    <Tooltip label={isCompleted ? "Mark Incomplete" : "Mark Complete"} placement="top" hasArrow>
      <Box
        onClick={handleClick}
        cursor={isDisabled ? "not-allowed" : "pointer"}
        opacity={isDisabled ? 0.4 : 1}
        display="inline-flex"
        alignItems="center"
      >
        <Icon
          as={isCompleted ? LuCircleCheck : LuCircle}
          color={isCompleted ? "green.500" : "gray.400"}
          boxSize={size}
          transition="color 0.15s"
          _hover={!isDisabled ? { color: isCompleted ? "green.600" : "gray.500" } : undefined}
        />
      </Box>
    </Tooltip>
  );
}
